module.exports = __webpack_public_path__ + "static/media/sort-amount-down-solid.f068cd1b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sort-amount-down-solid.svg
// module id = 923
// module chunks = 32